export enum ServiceJobGanttViewType {
  ServiceJobs = "service-jobs",
  Users = "users",
}
